import { toast as sonnerToast, Toaster } from 'sonner';

const TOASTIFY_KEYS = new Set([
  'autoClose', 'toastId', 'position', 'hideProgressBar', 'closeOnClick',
  'pauseOnFocusLoss', 'draggable', 'pauseOnHover', 'rtl', 'newestOnTop', 'containerId',
]);

const mapOptions = (options) => {
  if (!options || typeof options !== 'object' || Array.isArray(options)) return undefined;
  const rest = {};
  for (const [key, value] of Object.entries(options)) {
    if (TOASTIFY_KEYS.has(key)) continue;
    rest[key] = value;
  }
  if (options.autoClose === false) rest.duration = Infinity;
  else if (typeof options.autoClose === 'number') rest.duration = options.autoClose;
  if (options.toastId != null) rest.id = options.toastId;
  return rest;
};

const typed = (type) => (message, options) => sonnerToast[type](message, mapOptions(options));

export const toast = Object.assign(
  (message, options) => sonnerToast.info(message, mapOptions(options)),
  {
    success: typed('success'),
    error: typed('error'),
    info: typed('info'),
    warning: typed('warning'),
    warn: typed('warning'),
    loading: typed('loading'),
    dismiss: (...args) => sonnerToast.dismiss(...args),
    promise: sonnerToast.promise,
  }
);

export { Toaster };
